import * as React from 'react';
import GroupsTable from '../components/GroupsTable';
import DeleteOrganizationGroupModal from '../modals/DeleteOrganizationGroupModal';
import EditOrganizationGroupModal from '../modals/EditOrganizationGroupModal';
import useOrganizationGroups from '../useHooks/useOrganizationGroups';
import { useModal } from '@moovly/ui';
import useMembers from '../../../hooks/useMembers';

const GroupsListContainer = () => {
  const { groups } = useOrganizationGroups();
  const { members } = useMembers();

  const transformedGroups = React.useMemo(() => {
    return groups.map((gr) => ({
      ...gr,
      totalUsers: members.filter((memb) => memb.group_id === gr.id).length,
    }));
  }, [groups, members]);
  const {
    openModal: openEditOrganizationGroupModal,
    modalProps: editGroup,
    isOpen: editGroupModalOpen,
    ...otherEditGroupModalProps
  } = useModal();
  const {
    openModal: openDeleteOrganizationGroupModal,
    modalProps: deleteGroup,
    isOpen: deleteGroupModalOpen,
    ...otherDeleteGroupModalProps
  } = useModal();

  return (
    <div>
      <GroupsTable
        groups={transformedGroups}
        onEdit={openEditOrganizationGroupModal}
        onDelete={openDeleteOrganizationGroupModal}
      />
      {deleteGroupModalOpen && <DeleteOrganizationGroupModal group={deleteGroup} {...otherDeleteGroupModalProps} />}
      {editGroupModalOpen && <EditOrganizationGroupModal group={editGroup} {...otherEditGroupModalProps} />}
    </div>
  );
};

export default GroupsListContainer;
